module.exports = __webpack_public_path__ + "static/media/9D.a578d7b2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/9D.svg
// module id = 82
// module chunks = 0